module.exports = __webpack_public_path__ + "img/zhongji.b82a5cb3.png";